import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HelpCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * Floating "?" button, bottom-right. Hidden on auth and landing pages,
 * and on the /ayuda page itself. Always visible for authenticated users.
 */
const HelpFloatingButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { user } = useAuth();

  const hiddenPaths = ['/login', '/register', '/forgot-password', '/reset-password', '/ayuda', '/help'];
  if (hiddenPaths.some(p => location.pathname.startsWith(p))) return null;
  if (!user) return null; // only for logged-in users

  return (
    <button
      onClick={() => navigate('/ayuda')}
      data-testid="help-floating-btn"
      data-tour="help-button"
      title={t('help.floating.tooltip', 'Ayuda')}
      className="fixed bottom-24 right-6 z-40 w-14 h-14 rounded-full bg-gradient-to-br from-amber-500 to-rose-500 text-white shadow-xl hover:shadow-2xl hover:scale-105 active:scale-95 transition-all flex items-center justify-center group"
      aria-label={t('help.floating.tooltip', 'Ayuda')}
    >
      <HelpCircle className="w-6 h-6" />
      <span className="absolute right-full mr-3 px-3 py-1.5 bg-slate-800 text-white text-xs rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        {t('help.floating.tooltip', 'Ayuda')}
      </span>
    </button>
  );
};

export default HelpFloatingButton;
